import initVerge from './initVerge';

initVerge();